import React from "react"
import styled from "styled-components"
import DashLineHorizontal from "../../components/EnergyTrading/DashLineHorizontal"
import DashLineVertical from "../../components/EnergyTrading/DashLineVertical"
import DashLineTwoToThree from "../../components/EnergyTrading/DashLineTwoToThree"
import TelephonePole from "../../asset/icon/TelephonePole"
import Page2Table from "./Page2Table"
import LineVertical from "../../components/EnergyTrading/LineVertical"
import LineHorizontal from "../../components/EnergyTrading/LineHorizontal"
import LineTwoToThree from "../../components/EnergyTrading/LineTwoToThree"

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1 0 0;
  align-self: stretch;
`

const PageArrowWrapper = styled.div`
  display: flex;
  width: 96px;
  height: 136px;
  justify-content: center;
  align-items: center;
`

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  flex: 1 0 0;
  align-self: stretch;
`

const LeftWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
`

const Margin = styled.div`
  display: flex;
  width: 600px;
  justify-content: center;
  align-items: center;
`

const Infograpic = styled.div`
  display: flex;
  width: 440px;
  align-items: flex-start;
  align-content: flex-start;
  gap: 160px 248px;
  flex-shrink: 0;
  flex-wrap: wrap;
  position: relative;
`

const RegionBadge = styled.div`
  display: flex;
  width: 96px;
  height: 96px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;

  border-radius: 99px;
  background: var(--base-gray20, #dedede);

  color: var(--base-gray80, #5e5e5e);
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const OneToTwo = styled.div`
  display: flex;
  width: 224px;
  height: 29px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  position: absolute;
  left: 108px;
  top: 19px;
`

const OneToTwoLine = styled.div`
  display: flex;
  width: 224px;
  height: 29px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  position: absolute;
  left: 105px;
  top: 30px;
`

const OneToTwoText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-gray100, #262626);
  text-align: right;
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  width: 200px;
  text-align: center;

  position: absolute;
  left: 120px;
  top: 17px;
`

const OneToThree = styled.div`
  display: flex;
  width: 68px;
  justify-content: flex-end;
  align-items: center;

  position: absolute;
  left: -20px;
  top: 108px;
`

const OneToThreeLine = styled.div`
  display: flex;
  width: 68px;
  justify-content: flex-end;
  align-items: center;

  position: absolute;
  left: -9px;
  top: 108px;
`

const OneToThreeText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-gray100, #262626);
  text-align: right;
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  position: absolute;
  left: -50px;
  top: 165px;
`

const OneToFour = styled.div`
  display: flex;
  height: 29px;
  /* transform: rotate(35deg); */
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;

  position: absolute;
  left: 158px;
  top: 144px;
`

const TwoToThree = styled.div`
  display: flex;
  width: 304px;
  height: 29px;
  /* transform: rotate(-35deg); */
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;

  position: absolute;
  left: 90px;
  top: 60px;
`

const TwoToThreeLine = styled.div`
  display: flex;
  width: 304px;
  /* transform: rotate(-35deg); */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  position: absolute;
  left: 65px;
  top: 90px;
`

const TwoToThreeText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-gray100, #262626);
  text-align: right;
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  transform: rotate(-35deg);

  position: absolute;
  left: 100px;
  top: 205px;
`

const ThreeToTwoLine = styled.div`
  display: flex;
  width: 304px;
  /* transform: rotate(-35deg); */
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;

  position: absolute;
  left: 65px;
  top: 87px;
`

const ThreeToTwoText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-gray100, #262626);
  text-align: right;
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  transform: rotate(-35deg);

  position: absolute;
  left: 240px;
  top: 105px;
`

const TwoToFour = styled.div`
  display: flex;
  width: 68px;
  align-items: center;

  position: absolute;
  right: -20px;
  top: 108px;
`

const TwoToFourLine = styled.div`
  display: flex;
  width: 68px;
  justify-content: flex-end;
  align-items: center;

  position: absolute;
  left: 339px;
  top: 108px;
`

const TwoToFourText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-gray100, #262626);
  text-align: right;
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;

  position: absolute;
  left: 405px;
  top: 165px;
`

const ThreeToFour = styled.div`
  display: flex;
  width: 224px;
  height: 29px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  position: absolute;
  left: 108px;
  bottom: 48px;
`

const ThreeToFourLine = styled.div`
  display: flex;
  width: 224px;
  height: 29px;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;

  position: absolute;
  left: 105px;
  top: 286px;
`

const ThreeToFourText = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--base-gray100, #262626);
  text-align: right;
  font-family: SUIT;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;

  width: 200px;
  text-align: center;

  position: absolute;
  left: 120px;
  top: 270px;
`

const SalesPurchaseVolume = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 16px;
`

const Sales = styled.div`
  display: flex;
  width: 176px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  border-radius: 16px;
  background: var(--secondary10, #eef1f9);

  color: var(--primary90, #253c64);
  font-family: SUIT;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const Purchase = styled.div`
  display: flex;
  width: 176px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  border-radius: 16px;
  background: var(--purple10, #eee8fa);

  color: var(--primary90, #253c64);
  font-family: SUIT;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`

const Unit3 = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`

const Unit3Item = styled.div`
  display: flex;
  padding: 4px 10px;
  justify-content: center;
  align-items: center;
  gap: 8px;

  border-radius: 99px;
  background: var(--secondary30, #dce3f5);

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const RightWrapper = styled.div`
  display: flex;
  width: 528px;
  flex-direction: column;
  align-items: flex-end;
  gap: 10px;
`

const RightHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  color: var(--base-gray100, #262626);
  font-family: SUIT;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

interface Props {
  대전Data: any
  보령Data: any
  여수Data: any
  정읍Data?: any
  rate?: number
}

const Page2 = (props: Props) => {
  const { 대전Data, 보령Data, 여수Data, 정읍Data, rate } = props

  return (
    <Wrapper>
      <PageArrowWrapper></PageArrowWrapper>
      <Content>
        <LeftWrapper>
          <Margin>
            <Infograpic>
              <RegionBadge>정읍</RegionBadge>
              <RegionBadge>대전</RegionBadge>
              <RegionBadge>보령</RegionBadge>
              <RegionBadge>여수</RegionBadge>
              <OneToTwo>
                <DashLineHorizontal />
              </OneToTwo>
              {정읍Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "대전광역시" &&
                    Number(item.sellGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <OneToTwoLine>
                      <LineHorizontal rotate />
                    </OneToTwoLine>
                    <OneToTwoText>
                      {filteredItem?.sellGen?.toFixed(0).toLocaleString()} MWh
                    </OneToTwoText>
                  </React.Fragment>
                ))}
              {정읍Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "대전광역시" &&
                    Number(item.buyGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <OneToTwoLine>
                      <LineHorizontal />
                    </OneToTwoLine>
                    <OneToTwoText>
                      {filteredItem?.buyGen?.toFixed(0).toLocaleString()} MWh
                    </OneToTwoText>
                  </React.Fragment>
                ))}

              <TwoToFour>
                <DashLineVertical />
              </TwoToFour>
              {대전Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "군산시" && Number(item.sellGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <TwoToFourLine>
                      <LineVertical rotate />
                    </TwoToFourLine>
                    <TwoToFourText>
                      {filteredItem?.sellGen?.toFixed(0).toLocaleString()} MWh
                    </TwoToFourText>
                  </React.Fragment>
                ))}
              {대전Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "군산시" && Number(item.buyGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <TwoToFourLine>
                      <LineVertical />
                    </TwoToFourLine>
                    <TwoToFourText>
                      {filteredItem?.buyGen?.toFixed(0).toLocaleString()} MWh
                    </TwoToFourText>
                  </React.Fragment>
                ))}

              <OneToThree>
                <DashLineVertical />
              </OneToThree>
              {정읍Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "보령시" && Number(item.sellGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <OneToThreeLine>
                      <LineVertical rotate />
                    </OneToThreeLine>
                    <OneToThreeText>
                      {filteredItem?.sellGen?.toFixed(0).toLocaleString()} MWh
                    </OneToThreeText>
                  </React.Fragment>
                ))}
              {정읍Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "보령시" && Number(item.buyGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <OneToThreeLine>
                      <LineVertical />
                    </OneToThreeLine>
                    <OneToThreeText>
                      {filteredItem?.buyGen?.toFixed(0).toLocaleString()} MWh
                    </OneToThreeText>
                  </React.Fragment>
                ))}

              <ThreeToFour>
                <DashLineHorizontal />
              </ThreeToFour>
              {보령Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "군산시" && Number(item.sellGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <ThreeToFourLine>
                      <LineHorizontal rotate />
                    </ThreeToFourLine>
                    <ThreeToFourText>
                      {filteredItem?.sellGen?.toFixed(0).toLocaleString()} MWh
                    </ThreeToFourText>
                  </React.Fragment>
                ))}
              {보령Data?.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "군산시" && Number(item.buyGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <ThreeToFourLine>
                      <LineHorizontal />
                    </ThreeToFourLine>
                    <ThreeToFourText>
                      {filteredItem?.buyGen?.toFixed(0).toLocaleString()} MWh
                    </ThreeToFourText>
                  </React.Fragment>
                ))}

              <TwoToThree>
                <DashLineTwoToThree />
              </TwoToThree>
              {대전Data.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "보령시" && Number(item.sellGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <TwoToThreeLine>
                      <LineTwoToThree rotate />
                    </TwoToThreeLine>
                    <TwoToThreeText>
                      {filteredItem?.sellGen?.toFixed(0).toLocaleString()} MWh
                    </TwoToThreeText>
                  </React.Fragment>
                ))}
              {대전Data.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "보령시" && Number(item.buyGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <ThreeToTwoLine>
                      <LineTwoToThree />
                    </ThreeToTwoLine>
                    <ThreeToTwoText>
                      {filteredItem?.buyGen?.toFixed(0).toLocaleString()} MWh
                    </ThreeToTwoText>
                  </React.Fragment>
                ))}

              <OneToFour>
                <DashLineTwoToThree rotation={70} />
              </OneToFour>
              {정읍Data.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "군산시" && Number(item.sellGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <TwoToThreeLine>
                      <LineTwoToThree rotate />
                    </TwoToThreeLine>
                    <TwoToThreeText>
                      {filteredItem?.sellGen?.toFixed(0).toLocaleString()} MWh
                    </TwoToThreeText>
                  </React.Fragment>
                ))}
              {정읍Data.tradeList
                .filter(
                  (item: any) =>
                    item.loc === "군산시" && Number(item.buyGen.toFixed(0)) > 0
                )
                .map((filteredItem: any, index: number) => (
                  <React.Fragment key={index}>
                    <ThreeToTwoLine>
                      <LineTwoToThree />
                    </ThreeToTwoLine>
                    <ThreeToTwoText>
                      {filteredItem?.buyGen?.toFixed(0).toLocaleString()} MWh
                    </ThreeToTwoText>
                  </React.Fragment>
                ))}
            </Infograpic>
          </Margin>
          <SalesPurchaseVolume>
            <Sales>
              계통 판매량
              <Unit3>
                <Unit3Item>정읍</Unit3Item>
                {Number(정읍Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
              <Unit3>
                <Unit3Item>대전</Unit3Item>
                {Number(대전Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
              <Unit3>
                <Unit3Item>보령</Unit3Item>
                {Number(보령Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
              <Unit3>
                <Unit3Item>여수</Unit3Item>
                {Number(여수Data?.sellGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
            </Sales>
            <TelephonePole />
            <Purchase>
              계통 구매량
              <Unit3>
                <Unit3Item>정읍</Unit3Item>
                {Number(정읍Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
              <Unit3>
                <Unit3Item>대전</Unit3Item>
                {Number(대전Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
              <Unit3>
                <Unit3Item>보령</Unit3Item>
                {Number(보령Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
              <Unit3>
                <Unit3Item>여수</Unit3Item>
                {Number(여수Data?.buyGrid?.toFixed(0) || 0)?.toLocaleString()}
              </Unit3>
            </Purchase>
          </SalesPurchaseVolume>
        </LeftWrapper>
        <RightWrapper>
          <RightHeader>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8"
              height="8"
              viewBox="0 0 8 8"
              fill="none"
            >
              <circle cx="4" cy="4" r="4" fill="#3957D3" />
            </svg>
            목표 자립률 {rate}%
          </RightHeader>
          <Page2Table
            대전Data={대전Data}
            보령Data={보령Data}
            여수Data={여수Data}
            정읍Data={정읍Data}
          />
        </RightWrapper>
      </Content>
      <PageArrowWrapper></PageArrowWrapper>
    </Wrapper>
  )
}

export default Page2
